import type { StateCreator } from "zustand"
import { create } from "@/app/state"

interface UpdateFlashcardModalState {
  isOpen: boolean
  flashcardId: string
  openModal: (flashcardId: string) => void
  closeModal: () => void
}

const state: StateCreator<UpdateFlashcardModalState> = (set) => ({
  isOpen: false,
  flashcardId: "",
  openModal: (flashcardId: string) => set({ isOpen: true, flashcardId }),
  closeModal: () => set({ isOpen: false, flashcardId: "" }),
})

export const useUpdateFlashcardModal = create<UpdateFlashcardModalState>()(state)
